import { useParams } from "react-router-dom";
import { useUserQuery } from "../monitor/User.state";

const useGameRole = () => {
    const { game_id } = useParams();
    const { game: gameRole } = useUserQuery(game_id);
    return gameRole
}

export default useGameRole